/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Readiness_OptimalInputs */

const en_ui_readiness_optimal = /** @type {(inputs: Ui_Readiness_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimal`)
};

const de_ui_readiness_optimal = /** @type {(inputs: Ui_Readiness_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimal`)
};

/**
* | output |
* | --- |
* | "Optimal" |
*
* @param {Ui_Readiness_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_readiness_optimal = /** @type {((inputs?: Ui_Readiness_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Readiness_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_readiness_optimal(inputs)
	return de_ui_readiness_optimal(inputs)
});